<template>
  <PMain v-model="themeData" :dataKey="key">
    <v-row>
      <v-col class="pa-10">
        <v-card>
          <v-card-text>
            <table>
              <tr>
                <td width="100">Version</td>
                <td>: {{ version.version }}</td>
              </tr>
              <tr>
                <td>Branch/ Hash</td>
                <td>: {{ version.branch }} / {{ version.hash }}</td>
              </tr>
              <tr>
                <td>Commit Date</td>
                <td>: {{ version.datetime }}</td>
              </tr>
              <tr>
                <td>Update Date</td>
                <td>: {{ version.dateDateTime }}</td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </PMain>
</template>

<script>
import PMain from "../components/PMain.vue";
import comminMixin from "../mixins/common";
import version from "../../version.json";

export default {
  mixins: [comminMixin],
  data: () => ({
    version: version,
  }),
  components: {
    PMain,
  },
  async mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
